module.exports = __webpack_public_path__ + "static/media/crown.d6c67fa7.svg";